import { createContext, FC, memo, PropsWithChildren, useState } from 'react';

const ErrorContext = createContext(false);

export const ErrorSetterContext = createContext<(hasError: boolean) => void>(
  () => {},
);

export const ErrorContextProvider: FC<PropsWithChildren> = memo(
  ({ children }) => {
    const [hasError, setHasError] = useState(false);

    return (
      <ErrorContext value={hasError}>
        <ErrorSetterContext.Provider value={setHasError}>
          {children}
        </ErrorSetterContext.Provider>
      </ErrorContext>
    );
  },
);

export default ErrorContext;
